import { render } from "./userSettings.vue?vue&type=template&id=3b56e711&scoped=true"
import script from "./userSettings.vue?vue&type=script&lang=js"
export * from "./userSettings.vue?vue&type=script&lang=js"

import "./userSettings.vue?vue&type=style&index=0&id=3b56e711&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b56e711"]])

export default __exports__